"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DonutChart = void 0;
var React = _interopRequireWildcard(require("react"));
var _highcharts = _interopRequireDefault(require("highcharts"));
var _highchartsReactOfficial = _interopRequireDefault(require("highcharts-react-official"));
var _charts = require("../../../utils/charts");
var _classify = _interopRequireDefault(require("../../../utils/classify"));
var _ChartWrapper = require("../ChartWrapper");
var _typographyModule = _interopRequireDefault(require("../../../styles/typography.module.css"));
var _DonutChartModule = _interopRequireDefault(require("./DonutChart.module.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
//$FlowFixMe[untyped-import]
//$FlowFixMe[untyped-import]
const DonutChart = _ref => {
  let {
    isLoading,
    classNames,
    cardTitle,
    customExportOptions,
    headerActions,
    series,
    drilldown,
    legend,
    centerText,
    centerSubtext,
    hasEmptyData,
    emptyText,
    ...userOptions
  } = _ref;
  const chartRef = React.useRef();
  const {
    highChart,
    subtitleClassNames,
    ...wrapperClassNames
  } = classNames || {};
  const defaultCenterHTML = `<span class=${(0, _classify.default)(_DonutChartModule.default.subtitleWrap, subtitleClassNames?.wrapper)}>
    <span class="${(0, _classify.default)(_typographyModule.default.jumboMedium, _DonutChartModule.default.subtitleText, subtitleClassNames?.text)}">
      ${centerText ? centerText : ''}
    </span>
    <span class="${(0, _classify.default)(_typographyModule.default.bodySmall, _DonutChartModule.default.subtitleSubtext, subtitleClassNames?.subtext)}">
      ${centerSubtext ? centerSubtext : ''}
    </span>
  <span>`;
  const donutChartSeries = series.map(seriesItem => ({
    ...seriesItem,
    data: seriesItem.data.map((dataItem, index) => ({
      ...dataItem,
      color: (0, _charts.getDataVizColor)(index)
    }))
  }));
  const addColorToDrilldownSeries = series => series?.map(seriesItem => ({
    ...seriesItem,
    data: seriesItem.data.map((dataItem, index) => ({
      ...dataItem,
      color: (0, _charts.getDataVizColor)(index)
    }))
  }));
  const donutDrilldown = drilldown ? {
    ...drilldown,
    series: addColorToDrilldownSeries(drilldown.series),
    breadcrumbs: {
      floating: false
    }
  } : {};
  const defaultLineChartOptions = (0, _charts.getDonutChartOptions)({
    legend,
    defaultCenterHTML
  });

  //$FlowFixMe[cannot-spread-inexact]
  const chartOptions = (0, _charts.mergeChartUserOptions)(defaultLineChartOptions, {
    series: donutChartSeries,
    drilldown: donutDrilldown,
    ...userOptions
  });
  return /*#__PURE__*/React.createElement(_ChartWrapper.ChartWrapper, {
    isLoading: isLoading,
    title: cardTitle,
    ref: chartRef,
    customExportOptions: customExportOptions,
    headerActions: headerActions,
    classNames: wrapperClassNames,
    hasEmptyData: hasEmptyData,
    emptyText: emptyText
  }, /*#__PURE__*/React.createElement(_highchartsReactOfficial.default, {
    highcharts: _highcharts.default,
    containerProps: {
      className: (0, _classify.default)(_DonutChartModule.default.donutChartContainer, highChart)
    },
    ref: chartRef,
    options: chartOptions
  }));
};
exports.DonutChart = DonutChart;